module.exports = __webpack_public_path__ + "img/banner_ecology.b3becd40.png";